import * as Actions from "./actions";

const initialState = {
  protocols: {
    isLoading: false,
    fetchTime: null,
  },
  agreements: {
    isLoading: false,
    fetchTime: null,
  },
  agreementFiles: {
    isLoading: false,
    content: "",
    errors: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    /** ************************************ */
    // Handle PROTOCOLS
    /** ************************************ */
    case Actions.PROTOCOLS.REQUEST:
      return { ...state,
        protocols: {
          isLoading: true,
          errors: null,
        } };

    case Actions.PROTOCOLS.SUCCESS:
      return { ...state,
        protocols: {
          isLoading: false,
          errors: null,
        } };

    case Actions.PROTOCOLS.FAILURE:
      return { ...state,
        protocols: {
          isLoading: false,
          errors: action.payload.data,
        } };

    /** ************************************ */
    // Handle AGREEMENTS
    /** ************************************ */
    case Actions.AGREEMENTS.REQUEST:
      return { ...state,
        agreements: {
          isLoading: true,
          errors: null,
        } };

    case Actions.AGREEMENTS.SUCCESS:
      return { ...state,
        agreements: {
          isLoading: false,
          errors: null,
        } };

    case Actions.AGREEMENTS.FAILURE:
      return { ...state,
        agreements: {
          isLoading: false,
          errors: action.payload.data,
        } };

    /** ************************************ */
    // Handle AGREEMENT FILES
    /** ************************************ */
    case Actions.AGREEMENT_FILES.REQUEST:
      return { ...state,
        agreementFiles: {
          isLoading: true,
          content: "",
          errors: null,
        } };

    case Actions.AGREEMENT_FILES.SUCCESS:
      return { ...state,
        agreementFiles: {
          isLoading: false,
          content: action.payload.response,
          errors: null,
        } };

    case Actions.AGREEMENT_FILES.FAILURE:
      return { ...state,
        agreementFiles: {
          isLoading: false,
          content: "",
          errors: action.payload.data,
        } };

    default:
      return state;
  }
};
